// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import BalanceHistory from './BalanceHistory';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(BalanceHistory);
